import React from 'react'
import aboutus from "../images/aboutus-photo.png";

function About() {
  return (
    <div>
        <div className='krishnagarlandbuy'>
          <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-7 mt-3">
    <h4 style={styles.smallTitle}>WE ARE TSK REALTORS</h4>
    <h3 style={styles.heading}>
          Building a{" "}
          <span style={styles.goldItalic}>Legacy of Excellence</span> in
          <br />
       <h2>  Real Estate</h2>
        </h3>

        <p style={styles.para}>
          TSK Realtors is a trusted real estate platform dedicated to connecting genuine landowners and buyers across West Bengal. We specialize in verified land listings with proper legal documentation, ensuring transparent and secure property transactions.
        </p>

         <a className='mb-3' href="/aboutus" style={styles.readMore}>
          Read More →
        </a>
 
                            </div>
                           

                            <div className="col-md-5 mt-3">
                                  <img src={aboutus} className="card-img-top" alt="aboutus"/>

                            </div>
                            </div>
                            </div>
                        </div>
                        <br/>
                        
              </div>          
    </div>
    
  )
}

const styles = {
  section: {
    minHeight: "100vh",
    background: "#020202",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "80px 70px",
    position: "relative",
    overflow: "hidden",
    backgroundImage:
      "linear-gradient(rgba(0,0,0,.94), rgba(0,0,0,.94)), url('https://www.transparenttextures.com/patterns/black-paper.png')",
  },

  left: {
    width: "52%",
    zIndex: 2,
  },

  smallTitle: {
    color: "#d7b34a",
    fontSize: "34px",
    fontWeight: "500",
    letterSpacing: "2px",
    marginBottom: "35px",
  },

  heading: {
    fontSize: "52px",
    lineHeight: "1.25",
    fontWeight: "400",
    marginBottom: "45px",
     color: "#ffff",
  },

  goldItalic: {
    color: "#d7b34a",
    fontFamily: "Georgia, serif",
    fontStyle: "italic",
    fontWeight: "460",
  },

  para: {
    fontSize: "24px",
    lineHeight: "1.55",
    color: "#f1f1f1",
    maxWidth: "950px",
    textAlign: "justify",
    marginBottom: "30px",
  },

  readMore: {
    color: "#fff",
    textDecoration: "none",
    fontSize: "24px",
    fontWeight: "700",
  },

  right: {
    width: "45%",
    position: "relative",
    minHeight: "600px",
  },

  founderImg: {
    position: "absolute",
    right: "0",
    top: "0",
    width: "400px",
    height: "300px",
    objectFit: "cover",
  },

  videoBox: {
    position: "absolute",
    right: "120px",
    bottom: "0",
    width: "650px",
    height: "330px",
    overflow: "hidden",
    boxShadow: "0 20px 50px rgba(0,0,0,0.5)",
  },

  buildingImg: {
     position: "absolute",
  right: "-40px",
  bottom: "0",
  width: "420px",
  height: "330px",
  overflow: "hidden",
  boxShadow: "0 20px 50px rgba(0,0,0,0.5)",
  
  },

  playBtn: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "110px",
    height: "110px",
    borderRadius: "50%",
    background: "rgba(255,255,255,0.55)",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "36px",
    backdropFilter: "blur(6px)",
  },

  chatBtn: {
    position: "fixed",
    right: "35px",
    bottom: "35px",
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    background: "#83d58b",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "34px",
    textDecoration: "none",
    zIndex: 9999,
  },
};
export default About